/** @typedef {'warning' | 'question'} ConfirmDialogIcon */

/**
 * @typedef {Object} ConfirmDialogOptions
 * @property {string} [title]
 * @property {string} message
 * @property {string} [confirmLabel]
 * @property {string} [cancelLabel]
 * @property {string} [confirmColor]
 * @property {ConfirmDialogIcon} [icon]
 * @property {boolean} [requireCheckbox] — case à cocher obligatoire pour activer Confirmer
 * @property {string} [checkboxLabel]
 */

/** @type {((options: ConfirmDialogOptions) => Promise<boolean>) | null} */
let openConfirmDialogImpl = null;

/** @param {((options: ConfirmDialogOptions) => Promise<boolean>) | null} fn */
export function registerConfirmDialog(fn) {
  openConfirmDialogImpl = fn;
}

/** @param {ConfirmDialogOptions} options */
export function openConfirmDialog(options) {
  if (openConfirmDialogImpl) {
    return openConfirmDialogImpl(options);
  }
  return Promise.resolve(window.confirm(options.message));
}
